import { useState, useLayoutEffect } from 'react';
import { changeTheme } from '../Redux/actions/menu';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import React from 'react';


export default function ChangeTheme(props:any) {
    const [show, setShow] = useState(false);
   const dispatch = useDispatch();
    const [theme, setTheme] = useState({
        secondaryColor: '#1C1816',
        backgroundColor: '#000',
        fontColor: "#fff",
        headerColor: "#000",
        borderColor: "#000",
        lightTheme: "#1c1816",
        borderTheme: "#1c1816",
        footerColor: "#fff",
        footerTheme: "#1c1816",
        themeBtn : "#000",
        lightthemeBtn: "#e4002b",
        dateTheme: "dark"
    });

    // Load the saved color theme from local storage on mount
    useLayoutEffect(() => {
        const savedTheme = localStorage.getItem('color-theme');

        if (savedTheme) {
            setTheme(JSON.parse(savedTheme));
        }
    }, []);

    // Update the color theme and save to local storage on button click
    function handleToggleClick() {
        setShow(true)
        const newTheme = {
            backgroundColor: '#f1f3f6',
            secondaryColor: '#fff',
            fontColor: "#000",
            headerColor: "#fff",
            borderColor: "#e4002b",
            lightTheme: "rgba(223,239,255,.3)",
            borderTheme: "#dfefff",
            footerTheme: "#f1f3f6",
            footerColor: "#fff",
            themeBtn: "#e4002b",
            lightthemeBtn : "#fff",
            dateTheme: "light",
        };
        dispatch(changeTheme("light"));
        setTheme(newTheme);
        localStorage.setItem('color-theme', JSON.stringify(newTheme));
        localStorage.setItem('theme', "white");
        let windowObj = (window as any)
        windowObj.dataLayer.push({ ecommerce: null });
        windowObj.dataLayer.push({
            'event': 'theme',
            'ecommerce': {
                'select': {                   
                    'theme': "light"
                }
            }
        });
    }

    // Update the CSS custom properties with the current color theme
    useLayoutEffect(() => {
        const root = document.documentElement;
        root.style.setProperty('--black', theme.backgroundColor);
        root.style.setProperty('--second-color', theme.secondaryColor);
        root.style.setProperty('--white', theme.fontColor);
        root.style.setProperty('--header-color', theme.headerColor);
        root.style.setProperty('--border-color', theme.borderColor);
        root.style.setProperty('--light-theme', theme.lightTheme);
        root.style.setProperty('--border-theme', theme.borderTheme);
        root.style.setProperty('--footer-theme', theme.footerTheme);
        root.style.setProperty('--footer-color', theme.footerColor);
        root.style.setProperty('--dark-mode', theme.themeBtn);
        root.style.setProperty('--light-mode', theme.lightthemeBtn);
        root.style.setProperty('--date-bg', theme.dateTheme);
    }, [theme]);


// ======
const [darktheme, setDarkTheme] = useState({
    secondaryColor: '#1C1816',
    backgroundColor: '#000',
    fontColor: "#fff",
    headerColor: "#000",
    borderColor: "#000",
    lightTheme: "#1c1816",
    borderTheme: "#1c1816",
    footerColor: "#fff",
    footerTheme: "#1c1816",
    themeBtn : "#000",
    lightthemeBtn: "#e4002b",
    dateTheme: "dark",
});



useLayoutEffect(() => {
    const savedTheme = localStorage.getItem('color-theme');

    if (savedTheme) {
        setDarkTheme(JSON.parse(savedTheme));
    }
}, []);

    function handleDarkClick() {
        setShow(true)
        const newTheme = {
            secondaryColor: '#1C1816',
            backgroundColor: '#000',
            fontColor: "#fff",
            headerColor: "#000",
            borderColor: "#000",
            lightTheme: "#1c1816",
            borderTheme: "#1c1816",
            footerColor: "#fff",
            footerTheme: "#1c1816",
            themeBtn : "#000",
            lightthemeBtn: "#e4002b",
            dateTheme: "dark",
        };
        dispatch(changeTheme("dark"));
        setDarkTheme(newTheme);
        localStorage.setItem('color-theme', JSON.stringify(newTheme));
        localStorage.setItem('theme', "black");
        let windowObj = (window as any)
        windowObj.dataLayer.push({ ecommerce: null });
        windowObj.dataLayer.push({
            'event': 'theme',
            'ecommerce': {
                'select': {                   
                    'theme': "dark"
                }
            }
        });
    }
    useLayoutEffect(() => {
        const root = document.documentElement;
        root.style.setProperty('--black', darktheme.backgroundColor);
        root.style.setProperty('--second-color', darktheme.secondaryColor);
        root.style.setProperty('--white', darktheme.fontColor);
        root.style.setProperty('--header-color', darktheme.headerColor);
        root.style.setProperty('--border-color', darktheme.borderColor);
        root.style.setProperty('--light-theme', darktheme.lightTheme);
        root.style.setProperty('--border-theme', darktheme.borderTheme);
        root.style.setProperty('--footer-theme', darktheme.footerTheme);
        root.style.setProperty('--footer-color', darktheme.footerColor);
        root.style.setProperty('--dark-mode', darktheme.themeBtn);
        root.style.setProperty('--light-mode', darktheme.lightthemeBtn);
        root.style.setProperty('--date-bg', darktheme.dateTheme);
    }, [darktheme]);

    const { t } = useTranslation();
    return (
        <div className='theme-color'>
            <button className='theme-button-dark' onClick={handleToggleClick}>{t("DAY")}</button>
            <button className=' theme-button-light' onClick={handleDarkClick}>{t("NIGHT")}</button>
        </div>
    )
}
